<template>
  <div class="d-inline-flex align-center" style="border-radius: 4px;">
    <v-text-field
      ref="input"
      class="white"
      style="margin-right: -1px; border-right: none;"
      persistent-placeholder dense outlined hide-details hide-spin-buttons type="number"
      :label="label"
      :placeholder="placeholder"
      :disabled="disabled"
      :min="min"
      :max="max"
      :step="step"
      :rules="[
        v => (!required && !v) || (isInt(v) && (parseInt(v) >= min) && (parseInt(v) <= max)),
        ...rules.map(rule => (v => rule(parseInt(v))))
      ]"
      :value="value"
      v-on="{ ...$listeners, input }"
    />
    <div
      v-if="!hideStepper"
      class="ml-3 flex-grow-0 btn-group btn-group-horizontal"
      style="border-radius: 4px; user-select: none;"
    >
      <v-btn
        class="px-3 outline-hover white"
        style="height: 40px; margin-right: -.5px;"
        text color="primary"
        :disabled="disabled || (isInt(value) && (parseInt(value) <= min))"
        @click="inc(-1)"
      >
        <v-icon v-html="mdiMinus" />
      </v-btn>
      <v-btn
        class="px-3 outline-hover white"
        style="height: 40px; margin-left: -.5px;"
        text color="primary"
        :disabled="disabled || (isInt(value) && (parseInt(value) >= max))"
        @click="inc(1)"
      >
        <v-icon v-html="mdiPlus" />
      </v-btn>
    </div>
  </div>
</template>


<style scoped>
.outline-hover {
  outline: thin solid rgba(0, 0, 0, 0.38);
  outline-offset: -1px;
}
.outline-hover:hover {
  outline: thin solid rgba(0, 0, 0, 0.86);
}
.outline-hover.v-btn--disabled {
  outline: thin solid rgba(0, 0, 0, 0.26);
}
</style>


<script>
import { mdiMinus, mdiPlus } from '@mdi/js';

export default {
  name: 'int-field',

  props: {
    value: [ Number, String ],
    disabled: Boolean,
    required: Boolean,
    min: { type: Number, default: 0 },
    max: { type: Number, default: Number.MAX_SAFE_INTEGER },
    step: { type: Number, default: 1 },
    hideStepper: Boolean,
    label: String,
    placeholder: String,
    rules: { type: Array, default: () => [] }
  },

  created() {
    Object.assign(this, { mdiMinus, mdiPlus });
  },

  methods: {
    isInt(v) {
      return _.isInteger(v) || (v == '0') || /^-?[1-9]\d*$/.test(v);
    },

    inc(d) {
      this.$emit('input', this.isInt(this.value) ? Math.max(this.min, Math.min(this.max, parseInt(this.value) + d * this.step)) : this.min);
    },

    input(v) {
      this.$emit('input', this.isInt(v) ? parseInt(v) : (v || ''));
    }
  }
}
</script>
